import { render, staticRenderFns } from "./FollowUpTimeLineWidgetComponent.vue?vue&type=template&id=2b5e8a0a&"
import script from "./FollowUpTimeLineWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./FollowUpTimeLineWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpTimeLineWidgetComponent.vue?vue&type=style&index=0&id=2b5e8a0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports